import { Button, ButtonProps } from "antd";
import { CLAIMS } from "src/constants";
import { withRBAC } from "src/HOC/withRBAC";
import { useLazyGetDashboardTransactionsQuery } from "src/store/apis/Transactions";
import { exportToCSV } from "src/utility/utility";
import { TABLE_PAGE_SIZE } from "../constants";

interface Props extends ButtonProps {
  endpoint?: string;
  filter?: string;
}

// this number is used to contraint in the endpoint that it defaults to page size 1 when not provided
const MAX_PAGE_SIZE = 1000000;

function ExportToCSVButton({ filter, endpoint, ...props }: Props) {
  const [fetch, { isFetching }] = useLazyGetDashboardTransactionsQuery();

  const handleExport = () => {
    if (!endpoint) return;

    fetch({
      endpoint,
      filter: filter,
      pageSize: filter ? MAX_PAGE_SIZE : TABLE_PAGE_SIZE,
    }).then(({ data }) => {
      exportToCSV(data?.result?.items ?? [], "table-data.csv");
    });
  };

  return (
    <Button
      loading={isFetching}
      onClick={handleExport}
      type="default"
      className="bg-primary text-white"
      {...props}
    >
      Export to CSV
    </Button>
  );
}

export default withRBAC(ExportToCSVButton, [CLAIMS.EXPORT]);
